import { Dayjs } from "dayjs";
import { LloFunnelReportItem } from "../../../../api";

export type SortableColumn =
  | "caseName"
  | "raa"
  | "ap"
  | "upcomingDeadlines"
  | "lloExpiration"
  | "negotiation"
  | "funnel"
  | "dueDate"
  | "taskName"
  | "taskAssignee"
  | "description";

export type SortDirection = "asc" | "desc";

export type HeadCell = {
  id: SortableColumn;
  label: string;
  /** Preferred share of table width (sums with other columns ≈ 100). */
  widthPct: number;
};

export type RowWithSpans = LloFunnelReportItem & {
  rowNumber?: number;
  groupRowSpan?: number;
  skipCaseColumns?: boolean;
  isLastInCaseGroup?: boolean;
};

export type LloFunnelFiltersState = {
  caseName: string;
  raa: string;
  ap: string;
  lloExpiration: string;
  negotiation: string;
  funnel: string;
  taskName: string;
  taskAssignee: string;
  dueDateFrom: Dayjs | null;
  dueDateTo: Dayjs | null;
};

export type FilterFieldKey = Exclude<
  keyof LloFunnelFiltersState,
  "dueDateFrom" | "dueDateTo"
>;

export const EMPTY_FILTERS: LloFunnelFiltersState = {
  caseName: "",
  raa: "",
  ap: "",
  lloExpiration: "",
  negotiation: "",
  funnel: "",
  taskName: "",
  taskAssignee: "",
  dueDateFrom: null,
  dueDateTo: null,
};

export const FILTER_FIELD_LABELS: Record<FilterFieldKey, string> = {
  caseName: "Case",
  raa: "RAA",
  ap: "AP",
  lloExpiration: "LLO Expiration",
  negotiation: "Negotiation",
  funnel: "Funnel",
  taskName: "Task",
  taskAssignee: "Task Assignee",
};

export const SORT_FIELD_OPTIONS: { value: SortableColumn; label: string }[] = [
  { value: "caseName", label: "Case Name" },
  { value: "raa", label: "RAA" },
  { value: "ap", label: "AP" },
  { value: "lloExpiration", label: "LLO Expiration" },
  { value: "negotiation", label: "Negotiation" },
  { value: "funnel", label: "Funnel" },
  { value: "dueDate", label: "Due Date" },
  { value: "taskName", label: "Task" },
  { value: "taskAssignee", label: "Task Assignee" },
  { value: "description", label: "Description" },
  { value: "upcomingDeadlines", label: "Upcoming Deadlines" },
];

export const SORT_DIRECTION_OPTIONS: { value: SortDirection; label: string }[] = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];
